import React from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'src/utils/helpers'
import { Text, Flex } from '@chakra-ui/react'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'
import styles from './styles.module.less'

const PolicyItemDisplayValue = ({ policy, item, showIcon = true }) => {
  if (isEmpty(policy) || isEmpty(item)) {
    return ''
  }

  const isAuto = policy.hasOwnProperty('category') && policy.category === 'auto'
  const isProperty = policy.hasOwnProperty('category') && policy.category === 'property'

  return (
    <Flex align={'center'}>
      {showIcon && (isAuto || isProperty) ? (
        <div className={styles.itemIconHolder}>
          {isAuto && <FontAwesomeIconComponent icon={['fal', 'car']} size='sm' />}
          {isProperty && <FontAwesomeIconComponent icon={['fal', 'house']} size='sm' />}
        </div>
      ) : (
        ''
      )}
      <Flex direction={'column'}>
        <Text opacity={0.7} fontSize={'13px'}>
          {policy.hasOwnProperty('label') && policy.label.length > 0 ? policy.label : ''}
        </Text>
        <Text fontSize={'16px'}>
          {item.hasOwnProperty('year') && item.year ? item.year : ''}
          <Text as={'span'} ml={'5px'}>
            {item.title || ''}
          </Text>
        </Text>
      </Flex>
    </Flex>
  )
}

PolicyItemDisplayValue.propTypes = {
  policy: PropTypes.object.isRequired,
  // e.g. vehicle
  item: PropTypes.object.isRequired,
}

export default PolicyItemDisplayValue
